import { formatCurrency } from "../../../../infrastructure/utils/formatters";

/** تخمین درآمد — فقط نمایشی؛ بر اساس ظرفیت و نوع نیروگاه */
const BASE_KW = 5;
const BASE_MONTHLY_ON_GRID = 6_500_000;
const BASE_ANNUAL_ON_GRID = 78_000_000;
const CONTRACT_YEARS = 20;

function parseCapacityKw(request) {
  const title = request?.plantCapacityTitle || "";
  const match = String(title).match(/(\d+(?:\.\d+)?)/);
  if (match) return Number(match[1]);
  const cap = Number(request?.plantCapacity);
  return Number.isFinite(cap) && cap > 0 ? cap : BASE_KW;
}

function isOffGrid(request) {
  const t = (request?.powerPlantTypeTitle || "").toLowerCase();
  return t.includes("off") || t.includes("منفصل") || t.includes("آف");
}

export function estimateRequestIncome(request) {
  const kw = parseCapacityKw(request);
  const scale = kw / BASE_KW;
  const plantLabel = [request?.plantCapacityTitle, request?.powerPlantTypeTitle]
    .filter(Boolean)
    .join(" — ");

  const plantTypeKpi =
    request?.powerPlantTypeTitle || request?.plantCapacityTitle || "—";

  if (isOffGrid(request)) {
    return {
      available: true,
      plantTypeKpi,
      plantLabel: plantLabel || "نیروگاه خورشیدی",
      monthlyIncome: null,
      annualIncome: null,
      contractYears: CONTRACT_YEARS,
      offGridNote:
        "این نوع نیروگاه برای تأمین برق مصرفی طراحی شده و درآمد فروش برق ندارد.",
      disclaimer:
        "این اعداد تقریبی بوده و بر اساس تعرفه‌های فعلی محاسبه شده‌اند.",
    };
  }

  const monthly = Math.round(BASE_MONTHLY_ON_GRID * scale);
  const annual = Math.round(BASE_ANNUAL_ON_GRID * scale);

  return {
    available: true,
    plantTypeKpi,
    plantLabel: plantLabel || `${kw} کیلووات`,
    monthlyIncome: monthly,
    annualIncome: annual,
    contractYears: CONTRACT_YEARS,
    monthlyIncomeFormatted: formatCurrency(monthly),
    annualIncomeFormatted: formatCurrency(annual),
    offGridNote: null,
    disclaimer:
      "این اعداد تقریبی بوده و بر اساس تعرفه‌های فعلی محاسبه شده‌اند.",
  };
}
